/* D'ORVÉN cart drawer */
(function () {
  if (window.DorvenCart && window.DorvenCart.open) return;
  var root, panel, cfg = {}, cart = null, lastFocus = null, busy = false;

  function $(sel) { return root.querySelector(sel); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var cur = (cart && cart.currency) || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function base() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || cfg.root || '/'; }
  function shortName(t) { return String(t || '').split(' — ')[0]; }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function loading(on) { var l = $('[data-dv-cart-loading]'); if (l) l.hidden = !on; root.classList.toggle('is-busy', !!on); busy = !!on; }

  function request(path, body) {
    var opts = { headers: { 'Accept': 'application/json' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(base() + path, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function refresh() { return request('cart.js').then(function (c) { cart = c; render(); return c; }); }

  function updateCounts() {
    var n = cart ? cart.item_count : 0;
    document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    var c = $('[data-dv-cart-count]'); if (c) c.textContent = n ? '(' + n + ')' : '';
  }

  function render() {
    if (!cart) return;
    updateCounts();
    var items = cart.items || [];
    var list = $('[data-dv-cart-items]');
    var empty = items.length === 0;
    $('[data-dv-cart-empty]').hidden = !empty;
    $('[data-dv-cart-foot]').hidden = empty;

    list.innerHTML = items.map(function (it, i) {
      var free = it.final_line_price === 0 && it.original_line_price > 0;
      var disc = (it.line_level_discount_allocations || []).filter(function (d) { return d.amount > 0; }).map(function (d) { return d.discount_application && d.discount_application.title; }).filter(Boolean)[0];
      var finish = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var price = free
        ? '<span class="dv-ci__free">Free</span><s>' + money(it.original_line_price) + '</s>'
        : (it.final_line_price < it.original_line_price
            ? '<span class="is-now">' + money(it.final_line_price) + '</span><s>' + money(it.original_line_price) + '</s>'
            : '<span class="is-now">' + money(it.final_line_price) + '</span>');
      return '<li class="dv-ci' + (free ? ' is-free' : '') + '" data-key="' + esc(it.key) + '">' +
        '<a class="dv-ci__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 240)) + '" alt="" width="96" height="96" loading="lazy" style="opacity:1;visibility:visible">' : '') + '</a>' +
        '<div class="dv-ci__info">' +
          '<div class="dv-ci__top"><a class="dv-ci__name" href="' + esc(it.url) + '">' + esc(shortName(it.product_title)) + '</a>' +
          '<div class="dv-ci__price">' + price + '</div></div>' +
          (finish ? '<p class="dv-ci__finish">' + esc(finish) + '</p>' : '') +
          (disc ? '<p class="dv-ci__disc">' + esc(disc) + '</p>' : '') +
          '<div class="dv-ci__row">' +
            '<div class="dv-ci__qty" role="group" aria-label="Quantity">' +
              '<button type="button" data-dv-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-dv-qty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="dv-ci__remove" data-dv-remove>Remove</button>' +
          '</div>' +
        '</div></li>';
    }).join('');

    /* Totals */
    $('[data-dv-cart-subtotal]').textContent = money(cart.original_total_price);
    var discWrap = $('[data-dv-cart-discounts]');
    var groups = {};
    items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (d) {
        var t = (d.discount_application && d.discount_application.title) || 'Discount';
        groups[t] = (groups[t] || 0) + d.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) { groups[d.title || 'Discount'] = (groups[d.title || 'Discount'] || 0) + d.total_allocated_amount; });
    var itemSavings = items.reduce(function (s, it) { return s + Math.max(0, it.original_line_price - it.final_line_price); }, 0);
    var known = Object.keys(groups).reduce(function (s, k) { return s + groups[k]; }, 0);
    if (itemSavings - known > 0 && Object.keys(groups).length === 0) groups['Savings'] = itemSavings;
    discWrap.innerHTML = Object.keys(groups).map(function (t) { return '<div><dt>' + esc(t) + '</dt><dd class="is-save">&minus;' + money(groups[t]) + '</dd></div>'; }).join('');
    $('[data-dv-cart-total]').textContent = money(cart.total_price);
    

    renderOffer(items, groups);
    renderBumps(items);
  }

  function renderOffer(items, groups) {
    var box = $('[data-dv-cart-offer]');
    if (!box) return;
    var watches = (cfg.watches || []).map(String);
    var count = items.reduce(function (n, it) { return n + (watches.indexOf(String(it.product_id)) > -1 ? it.quantity : 0); }, 0);
    var applied = items.some(function (it) { return it.final_line_price === 0 && it.original_line_price > 0; });
    if (applied) {
      var saved = items.reduce(function (s, it) { return s + (it.original_line_price - it.final_line_price); }, 0);
      box.innerHTML = '<span class="dv-cart__offer-dot"></span><span>' + esc(cfg.offerApplied) + ' <b>You save ' + money(saved) + '</b></span>';
      box.className = 'dv-cart__offer is-applied'; box.hidden = false;
    } else if (count === 1) {
      box.innerHTML = '<span class="dv-cart__offer-dot"></span><span>' + esc(cfg.offerNudge) + '</span><a href="' + esc(cfg.offerLink) + '">Choose</a>';
      box.className = 'dv-cart__offer'; box.hidden = false;
    } else {
      box.hidden = true;
    }
  }

  function renderBumps(items) {
    var wrap = $('[data-dv-cart-bumps]'), list = $('[data-dv-cart-bump-list]');
    if (!wrap || !list) return;
    var inCart = items.map(function (it) { return String(it.product_id); });
    var bumps = (cfg.bumps || []).filter(function (b) { return inCart.indexOf(String(b.product_id)) === -1; });
    if (!items.length || !bumps.length) { wrap.hidden = true; list.innerHTML = ''; return; }
    wrap.hidden = false;
    list.innerHTML = bumps.map(function (b) {
      return '<li class="dv-bump">' +
        '<a class="dv-bump__img" href="' + esc(b.url) + '">' + (b.image ? '<img src="' + esc(b.image) + '" alt="" width="64" height="64" loading="lazy" style="opacity:1;visibility:visible">' : '') + '</a>' +
        '<div class="dv-bump__info"><p class="dv-bump__name">' + esc(b.title) + '</p>' +
          (b.text ? '<p class="dv-bump__text">' + esc(b.text) + '</p>' : '') +
          '<p class="dv-bump__price"><span>' + money(b.cents) + '</span>' + (b.compare > b.cents ? '<s>' + money(b.compare) + '</s>' : '') + '</p></div>' +
        '<button type="button" class="dv-bump__add" data-dv-bump="' + b.variant_id + '">Add</button>' +
      '</li>';
    }).join('');
  }

  function change(key, qty) {
    if (busy) return;
    loading(true);
    request('cart/change.js', { id: key, quantity: qty })
      .then(function (c) { cart = c; render(); })
      .catch(function (e) { flash((e && (e.description || e.message)) || 'Could not update your bag.'); })
      .then(function () { loading(false); });
  }

  function add(items) {
    loading(true);
    return request('cart/add.js', { items: items })
      .then(refresh)
      .catch(function (e) { flash((e && (e.description || e.message)) || 'Could not add to bag.'); throw e; })
      .then(function (c) { loading(false); return c; }, function (e) { loading(false); throw e; });
  }

  function flash(msg) {
    var p = $('.dv-cart__msg');
    if (!p) { p = document.createElement('p'); p.className = 'dv-cart__msg'; p.setAttribute('role', 'alert'); $('[data-dv-cart-body]').prepend(p); }
    p.textContent = msg;
    clearTimeout(p._t); p._t = setTimeout(function () { p.remove(); }, 5000);
  }

  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dv-cart-lock');
    setTimeout(function () { var x = root.querySelector('.dv-cart__x'); if (x) x.focus(); }, 60);
    refresh();
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('dv-cart-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function isCartLink(a) {
    if (!a) return false;
    if (a.classList && a.classList.contains('cart-drawer-button')) return true;
    var href = a.getAttribute && a.getAttribute('href');
    if (!href) return false;
    var cartPath = base() + 'cart';
    return href === '/cart' || href === cartPath || /\/cart\/?$/.test(href.split('?')[0]);
  }

  function init() {
    root = document.querySelector('[data-dv-cart]');
    if (!root || root.dataset.dvReady) return;
    root.dataset.dvReady = '1';
    panel = root.querySelector('.dv-cart__panel');
    try { cfg = JSON.parse(root.querySelector('[data-dv-cart-config]').textContent); } catch (e) { cfg = {}; }

    /* Intercept every cart link (header icon, mobile dock) before the theme sees it */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a, button.cart-drawer-button');
      if (!a || !isCartLink(a) || root.contains(a)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (/\/cart\/?$/.test(location.pathname)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      open();
    }, true);

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-dv-cart-close]')) { close(); return; }
      var li = e.target.closest('.dv-ci');
      var q = e.target.closest('[data-dv-qty]');
      if (q && li) {
        var current = parseInt(li.querySelector('.dv-ci__qty span').textContent, 10) || 1;
        change(li.getAttribute('data-key'), Math.max(0, current + parseInt(q.getAttribute('data-dv-qty'), 10)));
        return;
      }
      if (e.target.closest('[data-dv-remove]') && li) { li.classList.add('is-leaving'); change(li.getAttribute('data-key'), 0); return; }
      var b = e.target.closest('[data-dv-bump]');
      if (b) { b.disabled = true; b.textContent = 'Adding'; add([{ id: parseInt(b.getAttribute('data-dv-bump'), 10), quantity: 1 }]).catch(function () { b.disabled = false; b.textContent = 'Add'; }); }
    });
    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    document.addEventListener('dorven:cart:open', open);
    document.addEventListener('dorven:cart:refresh', refresh);
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) { if (root.closest('[id^="shopify-section"]') === e.target || e.target.contains(root)) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) close(); });
    }
    refresh().catch(function () {});
  }

  window.DorvenCart = { open: function () { init(); open(); }, close: close, refresh: function () { init(); return refresh(); }, add: function (items) { init(); return add(items); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { if (root && !document.body.contains(root)) { root = null; } init(); });
})();
